import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import './styles.css';

const IndicatorButton=(props)=>
{
    return <button className={'indicator-button btn '+props.className} disabled={props.disabled} onClick={props.onClick}>{(!props.disabled&&<span>{props.children}</span>)||<LinearProgress className="progress-bar" />}</button>
}

export default IndicatorButton;